import React from "react";

const COLORS = {
  emerald: "#059669",
  amber: "#d97706",
  rose: "#e11d48",
  zinc: "#a1a1aa",
};

// Simple animated SVG progress ring for the Daily Health score.
export function HealthScoreRing({ value = 0, color = "zinc", label, size = 132, stroke = 11 }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = Math.max(0, Math.min(100, value));
  const dash = (pct / 100) * c;
  const hex = COLORS[color] || COLORS.zinc;
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#f1f1f0" strokeWidth={stroke} />
        {pct > 0 && (
          <circle
            cx={size / 2}
            cy={size / 2}
            r={r}
            fill="none"
            stroke={hex}
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeDasharray={`${dash} ${c}`}
            style={{ transition: "stroke-dasharray 700ms cubic-bezier(0.22,1,0.36,1)" }}
          />
        )}
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-mono text-3xl font-black leading-none text-zinc-900" data-testid="health-score-ring-value">
          {Math.round(pct)}
        </span>
        {label && <span className="mt-1 text-[11px] font-semibold" style={{ color: hex }}>{label}</span>}
      </div>
    </div>
  );
}
